<template>
    <div class="latency-container">
        <el-button
            type="primary"
            class="add-latency-btn"
            size="small"
            icon="el-icon-plus"
            @click="addLatency"
        >Add latency</el-button>
        <div class="ns-paginate2">
            <el-table
                :data="latencies"
                :default-sort="{prop: 'value_ms', order: 'ascending'}"
                class="ns-paginate-table dark-theme"
            >
                <el-table-column prop="name" label="Name" sortable></el-table-column>
                <el-table-column prop="value_ms" label="Value (ms)" sortable></el-table-column>
                <el-table-column label="Default">
                    <template slot-scope="scope">
                        <el-tooltip
                            content="At least one default latency must be selected"
                            placement="top"
                            :disabled="scope.row.default !== true"
                        >
                            <el-switch
                                v-model="scope.row.default"
                                :disabled="scope.row.default === true"
                                active-text="Yes"
                                inactive-text="No"
                            ></el-switch>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" icon="el-icon-edit" @click="editLatency(scope.row)"></el-button>
                        <el-popconfirm
                            :title="`Are you sure to delete latency '${scope.row.name}'?`"
                            ref="test"
                            confirm-button-text="Yes"
                            cancel-button-text="No"
                            popper-class="gcmcn-popper"
                            @confirm="deleteLatency(scope.row)"

                        >
                            <el-button
                                slot="reference"
                                type="danger"
                                size="small"
                                icon="el-icon-delete"
                            ></el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <latency-edit-modal ref="modal" @latency-saved="updateLatenciesLocaly"></latency-edit-modal>
    </div>
</template>

<script>

import LatencyEditModal from './modal-edit-latency.vue';
import { cloneDeep } from 'lodash';
export default {

    components: {
        LatencyEditModal
    },

    props: {
    },

    data (){
        return {
            latencies: [],

        };
    },

    computed: {

    },

    watch: {
        latencies: {
            handler(val){
                let previousCheckedLatency = this.$store.getters.latencies.find((lat) => lat.default === true);
                let newCheckedLAtency = this.latencies.find((lat) => {
                    if(previousCheckedLatency){
                        return lat.default === true && lat.uid !== previousCheckedLatency.uid;
                    }
                    return lat.default === true;
                });
                if(newCheckedLAtency){
                    this.updateLatencyAfterDefaultChange(previousCheckedLatency, newCheckedLAtency);
                }
            },
            deep: true,
        },
    },
    mounted (){
        this.updateLatenciesLocaly();
    },

    methods: {
        updateLatenciesLocaly (){
            this.$set(this, 'latencies', cloneDeep(this.$store.getters.latencies));
        },
        editLatency (latency) {
            this.$refs.modal.open(latency);
        },
        deleteLatency (latency) {
            this.$store.dispatch('deleteItem', {
                item: latency,
                model: 'latencies',
            }).then((response) => {
                this.$notify({
                    type: 'success',
                    title: `Latency '${latency.name}' deleted`
                });
                this.updateLatenciesLocaly();
            }).catch((e) => {
                this.$notify({
                    type: 'error',
                    title: `Error on delete latency '${latency.name}'`
                });
            },)
        },
        addLatency () {
            this.$refs.modal.open();
        },

        updateLatencyAfterDefaultChange (previousCheckedLatency, newCheckedLAtency){
            let promise1 = null;
            if(previousCheckedLatency){
                let promise1 = this.$store.dispatch('patchItem', {
                    item: {
                        url: previousCheckedLatency.url,
                        default: false,
                    },
                    model: 'latencies',
                });
            }else{
                promise1 = Promise.resolve();
            }
            let promise2 = this.$store.dispatch('patchItem', {
                item: {
                    url: newCheckedLAtency.url,
                    default: true,
                },
                model: 'latencies',
            });
            Promise.all([promise1, promise2]).then((values) => {
                this.updateLatenciesLocaly();
                this.$notify({
                    type: 'success',
                    title: 'Default latency successfully changed'
                });
            }).catch((e) => {
                console.error(e);
                this.$notify({
                    type: 'error',
                    title: 'Error on change default latency'
                });
            });
        }
    },
};
</script>

<style lang="scss">
.gcmcn-popper{
    .el-popconfirm{
        color: #fff;
        .el-button--text{
            color: #fff;
        }
    }
}
.latency-container{
    .add-latency-btn{
        display: flex;
        margin-left: auto;
        margin-bottom: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Setting/Latency/index.vue